import { API, authFetch, formatApiErrorDetail } from "@/lib/api";

/** Télécharge un fichier binaire protégé par session. Vérifie le statut HTTP et le type MIME : jamais une page HTML ou une erreur JSON enregistrée sous .pdf/.csv. */
export async function downloadFile(path, filename, expectedType) {
  const res = await authFetch(`${API}${path}`);
  const ct = (res.headers.get("content-type") || "").toLowerCase();
  if (!res.ok) {
    let detail = `Erreur ${res.status}`;
    try { detail = formatApiErrorDetail((await res.json()).detail); } catch { /* corps non JSON */ }
    throw new Error(detail);
  }
  if (ct.includes("text/html") || (expectedType && !ct.includes(expectedType))) throw new Error("Le serveur n'a pas renvoyé le fichier attendu. Réessayez ou contactez le support.");
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url; a.download = filename; a.rel = "noopener";
  document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 10000);
}
